import { createApp } from 'vue';
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import Erecepta from './components/Erecepta/Erecepta.vue';
import Ezwolnienie from './components/Ezwolnienie/Ezwolnienie.vue';
import Tabletka from './components/Tabletka/Tabletka.vue';
import Antykoncepcja from './components/Antykoncepcja/Antykoncepcja.vue';
import Konsultacja from './components/Konsultacja/Konsultacja.vue';
import KonsultacjaPsychiatryczna from './components/KonsultacjaPsychiatryczna/KonsultacjaPsychiatryczna.vue';
import Skierowanie from './components/Skierowanie/Skierowanie.vue';
import SkierowanieSpecific from './components/SkierowanieSpecific/SkierowanieSpecific.vue';
import SkierowanieCT from './components/SkierowanieCT/SkierowanieCT.vue';
import PatientRegistration from './components/PatientRegistration/PatientRegistration.vue';
import PrenatalneVue from './components/Prenatalne/Prenatalne.vue';
import ReviewForm from './components/ReviewForm/ReviewForm.vue';
import StatusWizyty from './components/StatusWizyty/StatusWizyty.vue';

const app = createApp({});

if (window.config) {
    app.config.globalProperties.$config = window.config;
} else {
    console.warn("⚠️ window.config nie jest dostępne! Sprawdź, czy config.js został załadowany.");
}

app.use(PerfectScrollbarPlugin);

app.component('erecepta', Erecepta);
app.component('ezwolnienie', Ezwolnienie);
app.component('tabletka', Tabletka);
app.component('antykoncepcja', Antykoncepcja);
app.component('konsultacja', Konsultacja);
app.component('konsultacjapsychiatryczna', KonsultacjaPsychiatryczna);
app.component('skierowanie', Skierowanie);
app.component('prenatalne', PrenatalneVue);
app.component('skierowaniespecific', SkierowanieSpecific);
app.component('skierowaniect', SkierowanieCT);
app.component('patientregistration', PatientRegistration);
app.component('reviewform', ReviewForm);
app.component('statusWizyty', StatusWizyty);
app.mount('#app');
